import _taggedTemplateLiteral from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";

var _templateObject;

import styled from 'styled-components';
import dynamic from 'next/dynamic';
import { useIntlMeta } from '@yoweb/ui/hooks/useIntlMeta';
import { useTasks } from '@poplar/contexts/TaskContext/TaskProvider';
import { Box } from '@yoweb/ui/components/Box';
import { Title, Text } from '@yoweb/ui/components/typography';
import { useTranslation } from '@yoweb/next-i18next';
import { Button } from '@yoweb/ui/components/buttons';
import { th } from '@yoweb/ui/styles/utils/theme';
import { media } from '@yoweb/ui/styles/utils';
import { RenderOn } from '@yoweb/ui/components/RenderOn/RenderOn';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var TaskCardAnimationJa = dynamic(function () {
  return import('./LottieAnimationJa');
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [require.resolveWeak('./LottieAnimationJa')];
    }
  }
});
var TaskCardAnimationEn = dynamic(function () {
  return import('./LottieAnimationEn');
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [require.resolveWeak('./LottieAnimationEn')];
    }
  }
});
export var GetStarted = function GetStarted() {
  var _useTranslation = useTranslation('tasks'),
      t = _useTranslation.t;

  var _useIntlMeta = useIntlMeta(),
      lcLocale = _useIntlMeta.lcLocale;

  var isJapanLocale = lcLocale === 'ja-jp';

  var _useTasks = useTasks(),
      openTaskIntakeModal = _useTasks.actions.openTaskIntakeModal;

  return /*#__PURE__*/_jsxs(GetStartedSection, {
    "data-testid": "getting-started",
    children: [/*#__PURE__*/_jsx(Box, {
      h: "100%",
      w: "100%",
      backgroundColor: "lilacLight",
      position: "relative",
      py: {
        _: 'normal2',
        md: 'medium1'
      },
      overflow: "hidden",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      children: isJapanLocale ? /*#__PURE__*/_jsx(TaskCardAnimationJa, {}) : /*#__PURE__*/_jsx(TaskCardAnimationEn, {})
    }), /*#__PURE__*/_jsxs(Box, {
      display: "grid",
      alignItems: "center",
      justifyContent: "center",
      children: [/*#__PURE__*/_jsx(RenderOn.MobileOnly, {
        children: /*#__PURE__*/_jsxs(Box, {
          p: "normal2",
          display: "grid",
          justifyItems: "center",
          children: [/*#__PURE__*/_jsx(Title, {
            size: "sm",
            as: "h3",
            textAlign: "center",
            children: t('to-dos-page.get-started-card.title')
          }), /*#__PURE__*/_jsx(Box, {
            mt: "small3",
            display: "inline-block",
            children: /*#__PURE__*/_jsx(Text, {
              textAlign: "center",
              children: t('to-dos-page.get-started-card.text')
            })
          }), /*#__PURE__*/_jsx(Box, {
            mt: "normal2",
            children: /*#__PURE__*/_jsx(Button, {
              onClick: function onClick() {
                return openTaskIntakeModal();
              },
              children: t('to-dos-page.get-started-card.cta')
            })
          })]
        })
      }), /*#__PURE__*/_jsx(RenderOn.Tablet, {
        children: /*#__PURE__*/_jsxs(Box, {
          ml: "medium1",
          mr: "large3",
          children: [/*#__PURE__*/_jsx(Title, {
            size: "sm",
            as: "h3",
            children: t('to-dos-page.get-started-card.title')
          }), /*#__PURE__*/_jsx(Box, {
            mt: "small3",
            display: "inline-block",
            children: /*#__PURE__*/_jsx(Text, {
              children: t('to-dos-page.get-started-card.text')
            })
          }), /*#__PURE__*/_jsx(Box, {
            mt: "normal2",
            children: /*#__PURE__*/_jsx(Button, {
              onClick: function onClick() {
                return openTaskIntakeModal();
              },
              children: t('to-dos-page.get-started-card.cta')
            })
          })]
        })
      })]
    })]
  });
};
var GetStartedSection = styled.div.withConfig({
  componentId: "sc-87xh4m-0"
})(["display:grid;grid-template-columns:1fr;border-radius:", ";border:2px solid ", ";overflow:hidden;background-color:", ";", ""], th.getRadii('small'), th.getColor('sand'), th.getColor('base000'), media.md(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n      grid-template-columns: 1fr 1fr;\n    "]))));
export var EmptySection = styled.div.withConfig({
  componentId: "sc-87xh4m-1"
})(["padding:", ";border-radius:", ";border:2px solid ", ";overflow:hidden;place-items:center;display:grid;"], th.getSpace('normal3'), th.getRadii('small'), th.getColor('sand'));